import { render, staticRenderFns } from "./WjEdit.vue?vue&type=template&id=63d7096a&scoped=true&"
import script from "./WjEdit.vue?vue&type=script&lang=js&"
export * from "./WjEdit.vue?vue&type=script&lang=js&"
import style0 from "./WjEdit.vue?vue&type=style&index=0&id=63d7096a&scoped=true&lang=css&"
import style1 from "./WjEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d7096a",
  null
  
)

export default component.exports